import { Briefcase } from "lucide-react";
import { useWarRoomSnapshot } from "@/hooks/useWarRoomSnapshot";

/**
 * Sponsor-ready media metrics, derived from the existing war-room snapshot.
 * No additional polling — reuses cached react-query keys.
 */
export function SponsorMediaKit() {
  const { counters, pulse, tenants } = useWarRoomSnapshot();
  const sponsorImpressions = counters.sponsorImpressions?.total ?? 0;
  const sponsorClicks = counters.sponsorInteractions?.total ?? 0;
  const ctr = sponsorImpressions > 0 ? ((sponsorClicks / sponsorImpressions) * 100).toFixed(1) : "0.0";
  const clips = counters.clipExports?.total ?? 0;
  const shares = counters.shares?.total ?? 0;
  const topTenant = tenants[0];

  const stats: Array<{ label: string; value: string | number; hint?: string }> = [
    { label: "Active fans", value: pulse?.active_fans ?? 0, hint: "Live · global" },
    { label: "Hype burst", value: pulse?.hype_burst ?? 0, hint: "Last 60s" },
    { label: "Clip exports", value: clips, hint: "Creator output" },
    { label: "Shares", value: shares, hint: "Viral spread" },
    { label: "Sponsor CTR", value: `${ctr}%`, hint: `${sponsorClicks}/${sponsorImpressions}` },
    { label: "Top region", value: topTenant?.tenant_name ?? topTenant?.tenant_slug ?? "—", hint: topTenant ? `${topTenant.pulses} pulses` : undefined },
  ];

  return (
    <section className="rounded-2xl border border-border/60 bg-background/60 p-3">
      <h3 className="flex items-center gap-1.5 text-sm font-black uppercase tracking-wider">
        <Briefcase className="h-3.5 w-3.5 text-primary" /> Sponsor Media Kit
      </h3>
      <p className="mt-1 text-[11px] text-muted-foreground">
        Métricas listas para pitch — derivadas del War Room (sin tracking extra).
      </p>
      <div className="mt-3 grid grid-cols-2 gap-2 sm:grid-cols-3">
        {stats.map((s) => (
          <div key={s.label} className="rounded-lg border border-border/60 bg-background/70 p-2">
            <div className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">{s.label}</div>
            <div className="mt-0.5 text-lg font-black tabular-nums">{s.value}</div>
            {s.hint && <div className="text-[10px] text-muted-foreground">{s.hint}</div>}
          </div>
        ))}
      </div>
    </section>
  );
}